var render, staticRenderFns
import script from "./ProductSteps.vue?vue&type=script&lang=js&"
export * from "./ProductSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59cac444')) {
      api.createRecord('59cac444', component.options)
    } else {
      api.reload('59cac444', component.options)
    }
    
  }
}
component.options.__file = "src/js/components/ProductSteps.vue"
export default component.exports